import ModalContentWrapper from "root/Modals/ModalContentWrapper";
import IconTooltip from "ui/Tooltip/IconTooltip";
import React from "react";
import {MisSystemStatusArray, MisSystemStatusIds} from "root/s360components/Registration/MisSystemWritebackStatus";

const ModalMisWritebackInfo = () =>
{

    return (
        <ModalContentWrapper>
            <div>
                <div style={{textAlign: 'center'}}>
                    <h3>Mis Writeback indicators</h3>
                    <p>Below are 5 status indicators that show the different stages of mis registration writeback. This
                        shows the registration data that you
                        submit for this class and what stage it is at in the processing cycle. </p>
                </div>
                {MisSystemStatusArray.map((item) =>
                {
                    if (item.status_id !== MisSystemStatusIds.NEW)
                    {
                        return <div className={'info-item'} style={{margin: "20px", padding: "10px", background: "white", borderRadius: "10px", border: "thin solid black"}} key={item.status_id}>
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <h5>{item.status_text}</h5>
                                <IconTooltip icon={item.icon} color={item.color} placement='top'
                                             text={item.status_text} style={{marginLeft: "10px"}}/>
                            </div>
                            <p>{item.meaning}</p>
                        </div>
                    }
                })}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalMisWritebackInfo;